import { useLayoutEffect } from "react";
import useGeneralStore from "store/general";

/**
 * Collapses the sidebar on mount and restores it on unmount.
 * Use on pages that need maximum horizontal space (order entry, bill editing, etc.).
 */
export default function useFullScreenLayout() {
  const { setSidebarCollapsed } = useGeneralStore();

  useLayoutEffect(() => {
    setSidebarCollapsed(true);
    return () => {
      setSidebarCollapsed(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
